module.exports = __webpack_public_path__ + "Gauge4_Gray-49ccc7dde5d7e3c3d4a815d5e644e9ee.png";